<template>
     <ModalChangePhoto :visibleModalChangePhoto="isModalChangePhotoVisible"
                      @finishedActionHandler="finishedActionHandler"
                      @hideModalChangePhoto="hideModalChangePhoto">
    </ModalChangePhoto>
    <ModalRenewSignature :visibleModalRenewSignature="isModalRenewSignatureVisible"
                         @hideModalRenewSignature="hideModalRenewSignature" @reloadPage="reloadPage">
    </ModalRenewSignature>

    <nav class="navbar navbar-expand-lg bg-body-tertiary" v-if="isLoggedIn">
        <div class="container">
            <a class="navbar-brand" href="#">
                <img src="../assets/logo_up_bar_2024.png" @click="redirectHome"
                     width="230"
                     alt="Logo"/>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 mx-2">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" href="#" @click="home">Início</a>
                    </li>
                    <li class="nav-item" @click="medicalRecord">
                        <a class="nav-link" href="#">Prontuário</a>
                    </li>
                    <li class="nav-item" @click="historic">
                        <a class="nav-link" href="#">Últimos atendimentos</a>
                    </li>

                </ul>
                <div class="nav-item dropdown" title="Gerenciar perfil">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <img class="rounded-circle shadow-4" alt="imagem"
                             :src="this.User.photo_url ?? 'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grpetliq4fgm/b/doc4doc-public/o/assets%2Fuser_default.png'"
                             style="width: 40px;"/>
                        {{ User.name }}
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" @click="showModalChangePhoto()" data-bs-toggle="modal"
                               data-bs-target="#changePhotoModal">Alterar foto de perfil</a></li>
                        <li><a class="dropdown-item" href="#">{{ valueEnable ? "Ativo " : "Inativo " }}
                            <Toggle v-model="valueEnable" @change="changeStatus(valueEnable)"/>
                        </a></li>
                        <li v-if="isSignatureExpired()"><a class="dropdown-item" href="#"
                                                           @click="showModalRenewSignature()"
                                                           data-bs-toggle="modal"
                                                           data-bs-target="#renewSignatureModal">Renovar assinatura</a>
                        </li>
                        <li v-else><a class="dropdown-item" href="#">Expiração da assinatura: {{
                                userExpirationDate()
                            }} </a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" href="#" @click="logout">Sair</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
    <Connection-status></Connection-status>
</template>

<script>
import ConnectionStatus from "@/components/ConnectionStatus.vue";
import {mapActions, mapGetters} from "vuex";
import ModalChangePhoto from "@/components/ModalChangePhoto.vue";
import ModalRenewSignature from "@/components/ModalRenewSignature.vue";
import Toggle from "@vueform/toggle";

export default {

    name: "NavBar",
    components: {
        ModalChangePhoto,
        ConnectionStatus,
        Toggle,
        ModalRenewSignature
    },
    data() {
        return {
            isLoading: true,
            isModalChangePhotoVisible: false,
            isModalRenewSignatureVisible: false,
            valueEnable: false,
        };
    },
    async created() {
        if (!this.isAuthenticated()) {
            this.$router.push("/login");
        } else {
            try {
                await this.GetEnable();
                this.valueEnable = this.Enable;
                this.isLoading = false;
            } catch {
                this.$toast.error('Ocorreu um erro, tente novamente.', {
                    timeout: 3000,
                    closeOnClick: true
                });
            }
        }

    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isAuthenticated;
        },
        ...mapGetters({User: "StateUser", Enable: "StateEnable"}),
    },
    methods: {
        ...mapActions(["SetEnable"]),
        ...mapActions(["GetEnable"]),
        ...mapGetters(["isAuthenticated"]),

        userExpirationDate() {
            if (this.User.user_cess_access_info != null) {
                var dateString = this.User.user_cess_access_info.expired_at
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                return `${day}/${month}/${year} ${hours}:${minutes}`;
            }
        },
        isSignatureExpired() {
            const now = new Date();
            if (this.User.user_cess_access_info) {
                const dateExpired = new Date(this.User.user_cess_access_info.expired_at);
                return now > dateExpired;

            } else {
                return false
            }
        },
        finishedActionHandler() {
            this.hideModalChangePhoto();
            this.reloadPage();
        },
        reloadPage() {
            window.location.reload();
        },
        async logout() {
            this.isLoading = true;
            await this.$store.dispatch("LogOut");
            this.isLoading = true;
            this.$router.push("/login");
        },
        async home() {
            this.$router.push("/");
        },
        async historic() {
            this.$router.push("/historical");
        },
        async medicalRecord() {
            this.$router.push("/medical-record");
        },
        redirectHome() {
            this.$router.push("/");
        },
        showModalChangePhoto() {
            this.isModalChangePhotoVisible = true;
        },
        hideModalChangePhoto() {
            this.isModalChangePhotoVisible = false;
        },
        showModalRenewSignature() {
            this.isModalRenewSignatureVisible = true;
        },
        hideModalRenewSignature() {
            this.isModalRenewSignatureVisible = false;
        },
        async changeStatus(enable) {
            try {
                await this.SetEnable(enable === true ? 1 : 0)
                this.valueEnable = enable
                if (enable === true) {
                    this.$toast.success('Você está disponível para atender', {
                        timeout: 3000,
                        closeOnClick: true
                    });
                    setTimeout(() => {
                        this.$toast.warning('Atenção! Não se esqueça de desativar as notificações ao término do plantão.', {
                            timeout: 5000,
                            closeOnClick: true
                        });
                    }, 1000);
                } else {
                    this.$toast.warning('Você está indisponível para atender', {
                        timeout: 3000,
                        closeOnClick: true
                    });
                }
            } catch {
                this.$toast.error('Ocorreu um erro, tente novamente.', {
                    timeout: 3000,
                    closeOnClick: true
                });
            }
        },
    },
};
</script>
<style src="@vueform/toggle/themes/default.css"></style>

<style>

</style>
